import { graphql } from "gql";

const ADMIN_TAGS_SET_ACTIVE_MUTATION = graphql(`
  mutation AdminTagsSetActive($idList: [ID!]!, $active: Boolean!) {
    adminTagsSetActive(idList: $idList, active: $active) {
      ...Tag
    }
  }
`);

export default ADMIN_TAGS_SET_ACTIVE_MUTATION;
